document.addEventListener('DOMContentLoaded', () => {
    var shipping = {};
    var checkCep = function(cthis) {
        shipping.current = $(cthis).closest(".shipping-calculator");
        console.log(shipping.current[0])
        shipping.cepval = shipping.current.find(".address_zip").val();
        console.log(shipping.cepval)
        shipping.current.find(".new-get-rates").addClass("get-rates")
        if(shipping.cepval.length != 9) {
            alert("Digite um cep válido")
        }else {
            addProdCart();
        }
    }
    var addProdCart = function() {
        var variantid = $('#variantid');
        if(variantid[0] && !$('body').hasClass('open-cart-aside')) {
            var variantvalue = variantid.val();
            var cartItens;
    
            jQuery.getJSON('/cart.js', function(cart) {
                cartItens = cart.item_count;
                if(cartItens == 0) {
                    console.log("adicionando...")
                    $.post( "/cart/add.js", { quantity: 1, id: variantvalue }, function( data ) {
                        console.log('Adicionado')
                        carregaFrete(shipping.cepval);
    
                        setTimeout(function() {
                            $.post( "/cart/clear.js", function( data ) {
                                console.log("Cart clean");
                            }, "json");
                        }, 3000);
    
                    }, "json");                
                }else {
                    console.log(cartItens + " - itens no carrinho")
                    carregaFrete(shipping.cepval);
                } 
            });
        }else {
            carregaFrete(shipping.cepval);
        }
    }
    var carregaFrete = function(currentVal) {
        console.log("carrega frete");
        console.log(currentVal)
        shipping.current.find(".get-rates-custom").addClass("loading");
        shipping.current.find('.loading').addClass("load");
    
        $.getJSON("//viacep.com.br/ws/" + currentVal + "/json/?callback=?", function(dados) {
            if (!("erro" in dados)) {
                if(!shipping.current.find(".shipping-calculator")[0]) {
                    
                    shipping.current.find(".wrapper-response").attr("id", "wrapper-response");
                    if(!$("#shipping-calculator.active")[0]) {
                        Shopify.Cart.ShippingCalculator.show( {
                            submitButton: "Calcular", 
                            submitButtonDisabled: "Calculando...",
                            moneyFormat: moneyformat
                        });
                        $("#shipping-calculator").addClass('active');
                    }
                    shipping.current.find(".shipping-calculator").addClass("shiping-loaded");
                    setTimeout(() => {
                        shipping.current.find(".wrapper-response").removeAttr("id");
                    }, 5000);
                }
                var state;
                var uf = dados.uf.toUpperCase();
                switch (uf) {
                    case "AC" :	state = "Acre";					break;
                    case "AL" :	state = "Alagoas";				break;
                    case "AM" :	state = "Amazonas";				break;
                    case "AP" :	state = "Amapá";					break;
                    case "BA" :	state = "Bahia";					break;
                    case "CE" :	state = "Ceará";					break;
                    case "DF" :	state = "Distrito Federal";		break;
                    case "ES" :	state = "Espírito Santo";		break;
                    case "GO" :	state = "Goiás";					break;
                    case "MA" :	state = "Maranhão";				break;
                    case "MG" :	state = "Minas Gerais";			break;
                    case "MS" :	state = "Mato Grosso do Sul";	break;
                    case "MT" :	state = "Mato Grosso";			break;
                    case "PA" :	state = "Pará";					break;
                    case "PB" :	state = "Paraíba";				break;
                    case "PE" :	state = "Pernambuco";			break;
                    case "PI" :	state = "Piauí";					break;
                    case "PR" :	state = "Paraná";				break;
                    case "RJ" :	state = "Rio de Janeiro";		break;
                    case "RN" :	state = "Rio Grande do Norte";	break;
                    case "RO" :	state = "Rondônia";				break;
                    case "RR" :	state = "Roraima";				break;
                    case "RS" :	state = "Rio Grande do Sul";		break;
                    case "SC" :	state = "Santa Catarina";		break;
                    case "SE" :	state = "Sergipe";				break;
                    case "SP" :	state = "São Paulo";				break;
                    case "TO" :	state = "Tocantíns";				break;
                  }
                // shipping.current.find('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);
                // shipping.current.find('.get-rates').trigger('click');
                var timerjQuery = setInterval( function() {
                    if( $('[name="address[province]"] option')[0]) {
                        $('[name="address[province]"]').val(state); 
                        $('[name="address[province]"]').prop('selected', true);
                        shipping.current.find('.get-rates').trigger('click');
                        clearInterval( timerjQuery );
                    } 
                  }, 1000); 
            } else {
                flag = false;
                alert("CEP não encontrado");
            }
            
            $(".get-rates-custom").removeClass("loading");
            
        }).fail(function(jqXHR) {
            alert("Consulta de CEP indisponivel no momento")
        });    
    }
    $(function () {
        $(document).on('click', '.get-rates-custom', function() {
            checkCep($(this));
        });
        $(document).on('keypress', '.address_zip', function(event) {
            if(event.keyCode == 13) {
                event.preventDefault();
                checkCep($(this));
            }
        });
    });    
})
